(function () {
  function initBrandPage(root) {
    if (root.dataset.mr5BrandReady === 'true') return;
    root.dataset.mr5BrandReady = 'true';

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var reveals = root.querySelectorAll('.mr5-brand-reveal');

    if (reducedMotion || !('IntersectionObserver' in window)) {
      reveals.forEach(function (item) { item.classList.add('is-visible'); });
    } else {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px' });
      reveals.forEach(function (item) { observer.observe(item); });
    }

    root.querySelectorAll('[data-mr5-capabilities]').forEach(function (stage) {
      var tabs = Array.from(stage.querySelectorAll('[role="tab"]'));
      var panels = Array.from(stage.querySelectorAll('[role="tabpanel"]'));

      function selectTab(tab) {
        tabs.forEach(function (item) {
          var selected = item === tab;
          item.setAttribute('aria-selected', String(selected));
          item.tabIndex = selected ? 0 : -1;
        });
        panels.forEach(function (panel) {
          panel.hidden = panel.id !== tab.getAttribute('aria-controls');
        });
      }

      tabs.forEach(function (tab, index) {
        tab.addEventListener('click', function () { selectTab(tab); });
        tab.addEventListener('keydown', function (event) {
          if (event.key !== 'ArrowRight' && event.key !== 'ArrowDown' && event.key !== 'ArrowLeft' && event.key !== 'ArrowUp') return;
          event.preventDefault();
          var direction = event.key === 'ArrowRight' || event.key === 'ArrowDown' ? 1 : -1;
          var next = tabs[(index + direction + tabs.length) % tabs.length];
          selectTab(next);
          next.focus();
        });
      });
    });

    var hero = root.querySelector('[data-mr5-brand-hero]');
    if (hero && !reducedMotion && window.matchMedia('(pointer: fine)').matches) {
      hero.addEventListener('pointermove', function (event) {
        var rect = hero.getBoundingClientRect();
        hero.style.setProperty('--mr5-brand-x', ((event.clientX - rect.left) / rect.width - 0.5) * 18 + 'px');
        hero.style.setProperty('--mr5-brand-y', ((event.clientY - rect.top) / rect.height - 0.5) * 14 + 'px');
      });
      hero.addEventListener('pointerleave', function () {
        hero.style.setProperty('--mr5-brand-x', '0px');
        hero.style.setProperty('--mr5-brand-y', '0px');
      });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-mr5-brand-root]').forEach(initBrandPage);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
}());
